<template>
  <div
    class="grid grid-cols-4 gap-4 justify-between px-3 shadow-md bg-white py-5 border-l-10 rounded-md text-gray-400 mb-5 hover:shadow-lg"
    :class="borderColor"
  >
    <div class="date text-black title overflow-ellipsis whitespace-nowrap overflow-hidden"> {{ formattedDate }} </div>
    <div class="status">{{ transaction.status_short_formatted }}</div>
    <!-- v-html could be dangerous if not sanitized, considering the data is coming from the backend, and is valid -->
    <div class="title overflow-ellipsis whitespace-nowrap overflow-hidden" v-html="clientName"></div>
    <div class="amount title overflow-ellipsis whitespace-nowrap overflow-hidden">{{ formatCurrency }}</div>
  </div>

</template>

<script>
import { formatDate, formatCurrency } from '@/utils'
export default {
  props: {
    transaction: {
      type: Object,
      default: () => {}
    },
    searchQuery: {
      type: String,
      default: ''
    },
    colorDict: {
      type: Array,
      default: () => [{
        status: 'refunded',
        color: 'gray-300'
      }, {
        status: 'charged',
        color: 'lightBlue'
      }, {
        status: 'failed',
        color: 'red-400'
      }, {
        status: 'paid',
        color: 'easyGreen'
      }]
    }
  },
  computed: {
    formattedDate () {
      return formatDate(this.transaction.created_at)
    },
    borderColor () {
      return `border-${this.colorDict.find(item => item.status === this.transaction.status).color}`
    },
    clientName () {
      // add mark tag to search query and return the original case of the string
      if (this.searchQuery) {
        return this.transaction.client.name.replace(new RegExp(`(${this.searchQuery})`, 'gi'), '<mark>$1</mark>')
      } else {
        return this.transaction.client.name
      }
    },
    formatCurrency () {
      // use danish currency format in DKK
      return formatCurrency(this.transaction.amount)
    }
  }
}
</script>
